import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useStudentsService } from 'src/apis/students/useStudentsService';
import { ICreateAttendanceRequest } from 'src/apis/__shared/attendance.interfaces';
import { getStudentAttendanceByDateKey } from './useStudentAttendanceHook';

type TMutationError = IFHError<{ message: string }>;
type TAttendanceResponse = { message: string; date: string; recordsCount: number };

export const usePostAttendanceMutationHook = (
  options?: UseMutationOptions<
    TAttendanceResponse,
    TMutationError,
    ICreateAttendanceRequest,
    unknown
  >
) => {
  const { postStudentAttendance } = useStudentsService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: ICreateAttendanceRequest) =>
      postStudentAttendance(request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getStudentAttendanceByDateKey],
      });
    },
    ...options,
  });
};
